import { useCallback, useMemo } from 'react';
import { Box } from '@zillow/constellation-10';
import UploadedAttachmentCard from '../UploadedAttachmentCard';
import { linearGradientStyles, uploadedAttachmentListStyles, uploadedWrapperStyles } from './styles';
import { FILE_TYPES } from '../../../constants';
import type { ImagesViewerAttachment, UploadedAttachment } from '../../../types/attachment';

type Props = {
  uploadedAttachments: Array<UploadedAttachment>;
  onRemoveAttachment: (zDocId: string) => void;
  onImageClick: (zDocId: string, imageAttachments: Array<ImagesViewerAttachment>) => void;
};

export default function UploadedAttachmentList({ uploadedAttachments, onRemoveAttachment, onImageClick }: Props) {
  // Build image attachments array for viewer
  const imageAttachments = useMemo(
    () =>
      uploadedAttachments
        .filter(({ file }) => file.type.includes(FILE_TYPES.IMAGE))
        .map(({ file, generatedPreviewUrl, zDocId }) => ({
          fileName: file.name,
          fileSizeBytes: file.size,
          previewUrl: generatedPreviewUrl || null,
          zDocId: zDocId || file.name,
        })),
    [uploadedAttachments],
  );

  const handleImageClick = useCallback(
    (zDocId: string) => {
      onImageClick(zDocId, imageAttachments);
    },
    [onImageClick, imageAttachments],
  );

  return (
    <Box css={uploadedWrapperStyles}>
      <Box css={uploadedAttachmentListStyles}>
        {uploadedAttachments.map((uploadedAttachment) => {
          const { file, generatedPreviewUrl, zDocId } = uploadedAttachment;
          const { name, type, size } = file;
          const key = zDocId || `${name}-${size}`;

          return (
            <UploadedAttachmentCard
              key={key}
              fileName={name}
              fileType={type}
              imageSrc={generatedPreviewUrl || ''}
              onClick={handleImageClick}
              onRemove={onRemoveAttachment}
              zDocId={zDocId || ''}
            />
          );
        })}
      </Box>

      <Box css={linearGradientStyles} />
    </Box>
  );
}
